import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/ui/Button';
import Typography from 'components/ui/Typography';
import Tile from 'components/ui/Tile';
import { useModal } from 'hooks';

import css from './ConfirmModal.module.scss';

interface Props {
    handler: () => void;
    icon?: React.ReactNode;
    title?: string;
    subtitle?: React.ReactNode;
    yesCaption?: string;
    noCaption?: string;
    noHandler?: () => void;
}

const ConfirmModal: React.FC<Props> = ({ handler, icon, title, subtitle, yesCaption, noCaption, noHandler }) => {
    const { t } = useTranslation();
    const { closeModal } = useModal();

    return (
        <Tile isMobileFullscreen>
            <div className={css.container}>
                <Tile.Item>
                    <div className={css.content}>
                        {icon}
                        <Typography align="center" style="HeadMedSemibold">
                            {title ?? t('Modal.AreYouSure')}
                        </Typography>
                        {subtitle}
                        <div className={css.buttonGroup}>
                            <Button withPadding blocked onClick={handler}>
                                {yesCaption ?? t('Modal.Yes')}
                            </Button>
                            <Button withPadding blocked color="pale" onClick={noHandler ?? closeModal}>
                                {noCaption ?? t('Modal.No')}
                            </Button>
                        </div>
                    </div>
                </Tile.Item>
            </div>
        </Tile>
    );
};

export default React.memo(ConfirmModal);
